'use strict';

import Handlebars from 'injectify/runtime';

Handlebars.registerHelper('toLowerCase', function (stringToEdit = '') {

    return stringToEdit.toLowerCase();
});

Handlebars.registerHelper('toUpperCase', function (stringToEdit = '') {

    return stringToEdit.toUpperCase();
});

Handlebars.registerHelper('capitalize', function (stringToEdit = '') {

    return _.capitalize(stringToEdit);
});



// WEBPACK FOOTER //
// ./shared/helper/string.js